import React from "react";
import InfoCard from "./HomeInform/InfoCard";

const HomeInform = ({ Banner1, Banner2 }) => {
  return (
    <div className="container md:mb-14 mb-7">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 ml:gap-5 relative z-0">
        <InfoCard
          iconSrc="/widget.svg"
          iconWidth={111}
          iconHeight={113}
          title={Banner2?.baslik}
          description={Banner2?.kisa_icerik}
          bgClass="bg-bannerImage widget1 bg-themebgColor bg-cover bg-blend-overlay md:px-10 sm:px-5 px-3 ml:pt-1 pt-3 ml:pb-0 pb-3"
          link={Banner1?.url}
        />
        <InfoCard
          iconSrc="/icons/security.svg"
          iconWidth={74}
          iconHeight={79}
          title={Banner1?.baslik}
          description={Banner1?.kisa_icerik}
          bgClass="bg-securityImage widget2 bg-themeblackColor bg-cover bg-blend-overlay mix-blend-overlay md:px-10 sm:px-5 px-3 py-3"
          link={Banner2?.url}
        />
      </div>
    </div>
  );
};

export default HomeInform;
